<template>
<div>
  <div v-if="read_only">
    <h2 class="dark-orange--text font30 p-flex">SPCI</h2>
    <form_item :selectedItem="selectedItem" :read_only="read_only"/>
  </div>
  <w v-else :selectedItem="selectedItem"/>
</div>
</template>

<script>
import form_item from './sform.vue';
import w from './w.vue';
export default {
  props:['selectedItem','read_only'],
  components:{w,form_item},
};
</script>
